// extracted by mini-css-extract-plugin
module.exports = {"Login":"Login_Login__72dyW","buttons":"Login_buttons__jb6ZU"};